import React from "react";
import {
    Row,
    Col,
    Modal,
    Radio,
    DatePicker,
    Button
} from "antd";
import PropTypes from "prop-types";
import AccountsService from "services/facility-account-service";
import GridData from "./account-grid-data";
// import AccountProfileListView from "./AccountProfileListView";
import AccountStatementView from "./AccountStatementView";
import moment from "moment";
import {
    fetchAccountStatement,
    fetchAccountSummary,
    fetchFacilityAccountOpenInvoices
} from "store/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import RepaymentPlanList from "./RepaymentPlanList";

const START_DATE = "start_date";
const END_DATE = "end_date";
const RadioGroup = Radio.Group;
class AccountViewDetails extends React.Component {
    state = {
        facilityFetched: false,
        openInvoices: [],
        poolAmount: 0,
        sellerId: null,
        timestamp: null,
        filterModal: false,
        showFilterModal: false,
        filterValue: null,
        [START_DATE]: null,
        [END_DATE]: null
    };
    
    componentDidMount() {
        this.props.fetchAccountStatement(this.props.caseId);
        this.props.fetchAccountSummary(this.props.caseId);
        this.props.fetchFacilityAccountOpenInvoices(this.props.caseId);
    }

    handleDateInput = (type, _) => {
        if (
            type === END_DATE &&
            this.state[START_DATE] &&
            this.state[START_DATE].isAfter(_)
        ) {
            return;
        }
        if (
            type === START_DATE &&
            this.state[END_DATE] &&
            this.state[END_DATE].isBefore(_)
        ) {
            return;
        }
        this.setState({
            [type]: _
        });
    };

    toggleFilterModal = () => {
        this.setState({
            showFilterModal: !this.state.showFilterModal
        });
    };

    base64ToArrayBuffer = data => {
        var input = data.substring(data.indexOf(",") + 1);
        var binaryString = window.atob(input);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
        }
        return bytes;
    };

    onDownloadAccountStmt = () => {
        AccountsService.downloadAccountStmt(this.props.caseId, {
            [START_DATE]: this.state[START_DATE]
                ? this.state[START_DATE].format("YYYY-MM-DD")
                : null,
            [END_DATE]: this.state[END_DATE]
                ? this.state[END_DATE].format("YYYY-MM-DD")
                : null
        }).then(res => {
            var blob = new Blob([res.data], { type: "application/pdf" });
            var elem = window.document.createElement("a");
            elem.href = window.URL.createObjectURL(blob);
            elem.download = "b.pdf";
            document.body.appendChild(elem);
            elem.click();
            document.body.removeChild(elem);

            // concjp;
        });
    };

    filterStatement = () => {
        const { caseId, fetchAccountStatement } = this.props;
        if (this.state.filterValue) {
            if (this.state.filterValue === "1-month") {
                this.setState({
                    [START_DATE]: moment().subtract(1, "months"),
                    [END_DATE]: moment()
                });
            }
            if (this.state.filterValue === "3-months") {
                this.setState({
                    [START_DATE]: moment().subtract(3, "months"),
                    [END_DATE]: moment()
                });
            }
        }
        this.setState(
            {
                showFilterModal: false,
                debitFilter: false,
                creditFilter: false
            },
            () => {
                fetchAccountStatement(caseId, {
                    [START_DATE]: this.state[START_DATE]
                        ? this.state[START_DATE].format("YYYY-MM-DD")
                        : null,
                    [END_DATE]: this.state[END_DATE]
                        ? this.state[END_DATE].format("YYYY-MM-DD")
                        : null
                });
            }
        );
    };

    onChangeFilterValue = e => {
        this.setState({
            filterValue: e.target.value
        });
    };

    clearFilterStatement = () => {
        this.setState(
            {
                [START_DATE]: null,
                [END_DATE]: null,
                filterValue: null
            },
            () => this.filterStatement()
        );
    };

    renderFilterModal = () => {
        return (
            <React.Fragment>
                <Modal
                    title={"Filter"}
                    visible={this.state.showFilterModal}
                    onOk={this.filterStatement}
                    onCancel={this.toggleFilterModal}
                    destroyOnClose={false}>
                    <div className={"d-flex flex-column"}>
                        <RadioGroup
                            onChange={this.onChangeFilterValue}
                            value={this.state.filterValue}>
                            <Radio value={"1-month"}>1-Month</Radio>
                            <Radio value={"3-months"}>3-Months</Radio>
                            <Radio value={"custom"}>Custom Search</Radio>
                        </RadioGroup>
                        {this.state.filterValue === "custom" ? (
                            <div style={{ padding: "15px" }}>
                                <DatePicker
                                    style={{
                                        width: "100%"
                                    }}
                                    disabledDate={value =>
                                        value.valueOf() > moment().valueOf()
                                    }
                                    size={"large"}
                                    className={"mb-5"}
                                    onChange={this.handleDateInput.bind(
                                        null,
                                        START_DATE
                                    )}
                                    value={this.state[START_DATE]}
                                    placeholder={"Start Date"}
                                />
                                <DatePicker
                                    style={{
                                        width: "100%"
                                    }}
                                    disabledDate={value =>
                                        value.valueOf() > moment().valueOf()
                                    }
                                    size={"large"}
                                    className={"mb-5"}
                                    onChange={this.handleDateInput.bind(
                                        null,
                                        END_DATE
                                    )}
                                    value={this.state[END_DATE]}
                                    placeholder={"End Date"}
                                />
                            </div>
                        ) : null}
                        <Button
                            type={"default"}
                            className={"link-btn link-btn-dark"}
                            onClick={this.clearFilterStatement}
                            icon={"close"}>
                            Clear Filters
                        </Button>
                    </div>
                </Modal>
            </React.Fragment>
        );
    };

    render() {
        return (
            <React.Fragment>
                <Row className={"p-10"}>
                    <Col span={24} className={"p-5"}>
                        <GridData
                            data={this.props.accountSummary}
                            // status={"FETCHED"}
                        />
                    </Col>
                    <Col span={24} className={"p-5"}>
                        <RepaymentPlanList 
                            invoices={this.props.invoices}
                        />
                    </Col>
                    <Col span={24} className={"p-5"}>
                        <AccountStatementView
                            data={this.props.accountStatement}
                            downloadAccountStmt={this.onDownloadAccountStmt}
                            startDate={this.state.start_date}
                            endDate={this.state.end_date}
                            openFilterModal={this.toggleFilterModal}
                            status={this.props.accountStatementStatus}
                            fetchStatement={
                                this.props.fetchAccountStatement
                            }
                        />
                    </Col>
                </Row>
                {this.state.showFilterModal ? this.renderFilterModal() : null}
            </React.Fragment>
        );
    }
}

AccountViewDetails.propTypes = {
    caseId: PropTypes.number,
    companyId: PropTypes.number,
    fetchAccountStatement: PropTypes.func,
    fetchAccountSummary: PropTypes.func,
    accountSummary: PropTypes.object,
    accountStatement: PropTypes.array,
    accountStatementStatus: PropTypes.string,
    invoices: PropTypes.object,
    fetchFacilityAccountOpenInvoices: PropTypes.func
};

const mapStateToProps = (state) => ({
    accountSummary: state.accountViewInfo.getIn(["accountSummary", "data"]),
    accountStatement: state.accountViewInfo.getIn(["accountStatement", "data"]),
    accountStatementStatus: state.accountViewInfo.getIn(["accountStatement", "status"]),
    invoices: state.accountViewInfo.getIn(["openInvoices", "data"])
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchAccountSummary,
            fetchAccountStatement,
            fetchFacilityAccountOpenInvoices
        },
        dispatch
    );


export default connect(mapStateToProps, mapDispatchToProps)(AccountViewDetails);